export enum TypeImporters {
  Versions = 'versions',
  Vehicles = 'vehicles',
  Users = 'users',
  Assets = 'assets',
  Tasks = 'tasks',
  VehicleUsages = 'vehicle-usages',
  Invoices = 'invoices',
  Tags = 'tags',
  TagLinker = 'tagsLinker',
}
